import { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

mainNavigationStyles.menuItemTypography = {
    variant: "headerSecondary",
    color: "primary.contrast",
    css: css`
        font-weight: 600;
    `,
}

mainNavigationStyles.container = {
    css: css`
        color: ${getColor("common.background")};
        padding: 0 16px 0 0;
        display: flex;
        justify-content: left;
    `,
}

mainNavigationStyles.mobileSearchButton = {
    size: 50,
    buttonType: "solid",
    color: "primary",
   
}
